import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useQuoteCountStatusReducer = () =>
  useSelector((state: ApplicationState) => state.quoteCountStatus);
